import { useTranslation } from "react-i18next";

interface ErrorFallbackProps {
    error: unknown;
    resetError?: () => void;
}

export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
    const { t } = useTranslation();

    const message = error instanceof Error ? error.message : t("errors.unexpected");

    return (
        <div
            role="alert"
            className="border-destructive/20 bg-destructive/5 mx-auto max-w-lg rounded-lg border p-6 text-center"
        >
            <h2 className="text-destructive text-lg font-semibold">{t("common.states.error")}</h2>
            <p className="text-muted mt-2 text-sm">{message}</p>
            {resetError && (
                <button
                    type="button"
                    onClick={resetError}
                    className="bg-primary text-primary-foreground hover:bg-primary/90 mt-4 rounded-md px-4 py-2 text-sm font-medium transition-colors"
                >
                    {t("errors.tryAgain")}
                </button>
            )}
        </div>
    );
}
